import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import useSWR from "swr";
import { getStoryBySlug, useStoryblokState } from "@cinch-nx/data-storyblok";
import { getStoryBlokSlug, getStoryblokSlugFromUrl } from "../../utils";
import { useSearchFilters, useSearchStore } from "..";
import { Env, readFromEnv } from "@cinch-nx/environments";
import { useRouter } from "next/router";
var fetcher = function() {
    var _ref = _async_to_generator(function(param) {
        var slug, isInsideStoryblok, args;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    slug = param.slug, isInsideStoryblok = param.isInsideStoryblok;
                    args = _object_spread({
                        version: isInsideStoryblok ? "draft" : "published"
                    }, isInsideStoryblok && {
                        cv: Date.now()
                    });
                    return [
                        4,
                        getStoryBySlug(slug, args, {
                            strict: false
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function fetcher(_) {
        return _ref.apply(this, arguments);
    };
}();
export function useStoryblokData() {
    var ref, ref1, ref2;
    var isInsideStoryblok = useSearchStore(function(s) {
        return s.isInsideStoryblok;
    });
    var getRawFilters = useSearchFilters().getRawFilters;
    var rawFilters = getRawFilters();
    // use consistent slug generation logic between server & client when /used-cars SSR v2 feature flag is enabled
    var isUsedCarsSSRV2Enabled = readFromEnv(Env.SearchUsedCarsValidationV2) === "true";
    var asPath = useRouter().asPath;
    var slug = isUsedCarsSSRV2Enabled ? getStoryblokSlugFromUrl(asPath) : getStoryBlokSlug(rawFilters);
    var shouldFetch = slug !== "search/" && slug !== null;
    // See: https://swr.vercel.app/docs/conditional-fetching#conditional
    // and: https://swr.vercel.app/docs/arguments#multiple-arguments
    // For information on the advanced usage used here
    var ref3 = useSWR(shouldFetch ? [
        slug,
        isInsideStoryblok
    ] : null, function(param) {
        var _param = _sliced_to_array(param, 2), slug = _param[0], isInsideStoryblok = _param[1];
        return fetcher({
            slug: slug,
            isInsideStoryblok: isInsideStoryblok
        });
    }), data = ref3.data, error = ref3.error, isLoading = ref3.isLoading, isValidating = ref3.isValidating;
    var story = useStoryblokState({
        story: data || undefined,
        enableBridge: isInsideStoryblok
    });
    var content = story === null || story === void 0 ? void 0 : story.content;
    return {
        headingOverride: content === null || content === void 0 ? void 0 : content.HeadingOverride,
        intro: content === null || content === void 0 ? void 0 : (ref = content.Intro) === null || ref === void 0 ? void 0 : ref[0],
        faqs: content === null || content === void 0 ? void 0 : (ref1 = content.FAQ) === null || ref1 === void 0 ? void 0 : ref1[0],
        outro: content === null || content === void 0 ? void 0 : content.Outro,
        seo: content === null || content === void 0 ? void 0 : (ref2 = content.SEO) === null || ref2 === void 0 ? void 0 : ref2[0],
        isLoading: isLoading,
        isValidating: isValidating,
        error: error
    };
}
